/**
 * FrontpageHero section
 */
(function frontpageHeroFrontend($) {
	$(document).on('cms.ready', ready);

	let logged_in = false; // Nice-to-have: Logged in as a Contenda variable.

	/* Initial building of the ServiceCases */
	function ready() {
		logged_in = $('body.logged-in').length;

		if(logged_in) {
			// Set up intersect listener on document since that's the only way we can listen to newly added elements
			$(document).on('cms.intersect', '.sectionFrontpageHero', function intersect(evt, entry, $elm) {
				setupSection(0, $elm);
			});
		}

		$('.sectionFrontpageHero').each(setupSection);
	}

	function setupSection(i, elm) {


	}
})(jQuery);